module.exports = __webpack_public_path__ + "static/img/botian-new.aefe168f.png";